const unwrapPromiseSettledResult = <T>(result: PromiseSettledResult<T>, defaultValue?: T): T | undefined => {
    if (result.status === 'fulfilled') {
        return result.value;
    }
    return defaultValue;
};

export const PromiseHelpers = {
    unwrapPromiseSettledResult,
};
